import api from "../../services/api";

export default function SheetPreview({ jobId }) {
  return (
    <div className="mt-3 text-center">
      <img
        src={api.getLayoutingSheetPreview(jobId)}
        style={{
          width: "800px",
          height: "500px",
          objectFit: "contain",
        }}
        alt="preview"
      />
    </div>
  );
}
